import React, { useEffect } from 'react';
import { useStravaTranslations } from '@strava/container-context';
import {
  DisclaimerText,
  AccountAuthButton,
  APPLE,
  FACEBOOK,
  GOOGLE,
  EmailRegistrationForm,
  AnalyticsFieldsTypes,
  EmailRegistrationFormProps,
  OrDivider,
  EMAIL_REGISTRATION_FORM_ALERT_ID
} from '@strava/authentication-ui';
import { AlertContainer, AlertStatus, useAlertContext } from '@strava/ui/Alert';

type MobileRegistrationOptionsProps = EmailRegistrationFormProps & {
  track: (fields: AnalyticsFieldsTypes) => void;
  emailAuthorizationUrl: string;
  handleExtAuthBtnClick: (
    option: typeof FACEBOOK | typeof GOOGLE | typeof APPLE
  ) => void;
  cohort?: string | undefined;
  flashMessage?: string | undefined;
};

export const MobileRegistrationOptions = ({
  emailAuthorizationUrl,
  handleExtAuthBtnClick,
  track,
  flashMessage,
  ...emailRegFormProps
}: MobileRegistrationOptionsProps) => {
  const { t } = useStravaTranslations();
  const { showAlert } = useAlertContext();

  useEffect(() => {
    if (flashMessage) {
      showAlert({
        alertType: AlertStatus.ERROR,
        content: flashMessage,
        hideCloseButton: true,
        containerId: EMAIL_REGISTRATION_FORM_ALERT_ID,
        id: 'flashMessage'
      });
    }
  }, [flashMessage, showAlert]);

  const i18nPrefix = 'account_registration_page_ui';

  return (
    <>
      <AlertContainer containerId={EMAIL_REGISTRATION_FORM_ALERT_ID} />

      <div data-testid="auth-btns">
        <AccountAuthButton
          variant="facebook"
          onClick={() => handleExtAuthBtnClick(FACEBOOK)}
          data-testid="facebook_auth_btn"
        >
          {t(`${i18nPrefix}.signup_ctas.facebook_cta_v2`)}
        </AccountAuthButton>

        <AccountAuthButton
          variant="google"
          onClick={() => handleExtAuthBtnClick(GOOGLE)}
          data-testid="google_auth_btn"
        >
          {t(`${i18nPrefix}.signup_ctas.google_cta_v2`)}
        </AccountAuthButton>

        <AccountAuthButton
          variant="apple"
          onClick={() => handleExtAuthBtnClick(APPLE)}
          data-testid="apple_auth_btn"
        >
          {t(`${i18nPrefix}.signup_ctas.apple_cta_v2`)}
        </AccountAuthButton>

        <OrDivider
          text={t(`${i18nPrefix}.or_sign_up_with_email_v2`)}
          theme="light"
        />
        <EmailRegistrationForm
          authorizationUrl={emailAuthorizationUrl}
          track={track}
          theme="light"
          idPrefix="mobile"
          {...emailRegFormProps}
        />

        <DisclaimerText />
      </div>
    </>
  );
};

export default MobileRegistrationOptions;
